import './App.css';
import {useEffect} from 'react'
import Navbar from './components/Navbar';
import Hiro from './components/Hiro';
import Skills from './components/Skills'
import Honors from './components/Honors';
import Certs from './components/Certs';
import Footer from './components/Footer';
import AOS from 'aos';
import 'aos/dist/aos.css';


function App() {
    useEffect(() => {
      document.title = 'Bryant Lan - Portfolio';
      AOS.init();
    }, []);
  return (
    <div className="px-6 lg:px-20 xl:px-36 bg-dark-500">
      <Navbar />
      <Hiro />
      <Skills />
      <Honors />
      <Certs />
      <Footer />
    </div>
  );
}

export default App;


// eslint-disable-next-line no-unused-vars

let me = {
  name: "Bryant (Tu) Lan",
  programming_language: ["Go", "Python", "C#", "JavaScript"],
  container_orchestration: ["Kubernetes (CKA certified)", "Docker", "Helm", "ArgoCD"],
  ci_cd: ["GitHub Actions", "Azure DevOps"],
  cloud_platform: ["Azure (6x certified)", "AWS"],
  cloud_security: ["Microsoft Defender for Cloud", "Azure Sentinel", "Azure Key Vault", "Azure Policy", "RBAC", "Private Endpoint"],
  cloud_networking: ["Azure Virtual Network", "Azure Front Door", "Azure Traffic Manager", "Hub-Spoke Architecture", "Azure Private DNS"],
  operating_system: ["Ubuntu/Debian (LFCS certified)", "Windows"],
  imperative_scripting: ["Powershell", "Bash"],
  IaC: ["Bicep", "Terraform"],
  configuration: ["Ansible, Azure Automation, Azure Desired State Configuration"],
  secret_management: ["Azure Key Vault"],
  observability: ["Azure Monitor", "OpenTelemetry", "Dynatrace"],
  /* more important */
  message: "Welcome to my portfolio :)"
}






